import { createReduxSagaActionSubtypes as createSubtypes } from '@/utils/create-redux-saga-action-subtypes';

export const ProposalsActionTypes = {
  FETCH_PROPOSAL: createSubtypes('proposals|fetchProposalById'),
  SET_ASSIGMENT_PROGRESS: createSubtypes('proposals|assigment'),
};

export const ProposalMetricsActionTypes = {
  FETCH_PROPOSAL_METRIC: createSubtypes('proposalMetricss|fetchProposalMetric'),
};

export const ProposalMetricsDatesActionTypes = {
  FETCH_PROPOSAL_METRICS_DATES: createSubtypes('proposalMetricsDates|fetchProposalMetricsDates'),
};
